import React from 'react'

import { Button } from '@/components/Button'
import { DialogTrigger, Modal, Dialog, ModalHeader, ModalContent } from '@/components/Modal'
import { CompactTable } from '@/components/Table'
import { UserProfile } from '@/api/types'
import { useQuery } from '@tanstack/react-query'
import { fetchUser, usersQuery } from '@/api/users'
import { useAuth } from '@/auth'

type Props = {
  onSelect(entry: UserProfile): void
}
export default function UserProfileSelector({ onSelect }: Props) {
  return (
    <DialogTrigger>
      <Button>Load user profile</Button>
      <Modal>
        <Dialog>{({ close }) => <ProfileModal onSelect={onSelect} close={close} />}</Dialog>
      </Modal>
    </DialogTrigger>
  )
}

function ProfileModal({
  onSelect,
  close,
}: {
  onSelect: (user: UserProfile) => void
  close: () => void
}) {
  const auth = useAuth()
  const { data, isLoading } = useQuery(usersQuery(auth?.dbContext?.toLocaleLowerCase()))

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <>
      <ModalHeader onClose={close}>Select a User</ModalHeader>

      <ModalContent>
        <CompactTable
          aria-label="Users"
          columns={[
            {
              label: 'Email',
              key: 'email',
            },
          ]}
          rows={data || []}
          rowId="idUser"
          search={{
            columns: ['email'],
          }}
          onRowAction={async (idUser: number) => {
            const userProfile = await fetchUser(idUser.toString())
            onSelect(userProfile)
            close()
          }}
        />
      </ModalContent>
    </>
  )
}
